// 
import { React, useEffect, useState } from "react";
import "./about.css";
import img from "../../images/Mohamed_Safvan.jpg";
import { FaFacebookF, FaTwitter, FaLinkedinIn,FaInstagram, FaGithub,FaPhone,FaBehance ,FaLinkedin} from "react-icons/fa";
const url="https://eylocoin-site.stackstaging.com/"
const About = () => {
  const [currentResumeUrl, setCurrentResumeUrl] = useState("");

  const handleDownloadResume = async () => {
    try {
      const res = await fetch(currentResumeUrl);
      if (!res.ok) throw new Error("Failed to fetch resume PDF");

      const blob = await res.blob();
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "Mohamed_Safvan_VP_CV.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed:", err);
      alert("Could not download the resume.");
    }
  };

  useEffect(() => {
    const fetchResume = async () => {
      try {
        const res = await fetch(`${url}portfoilo/resume.php`);
        const data = await res.json();

        if (data.files && data.files.length > 0) {
          const sorted = data.files.sort().reverse(); // Sort by filename with timestamps
          const latest = sorted[0];

          setCurrentResumeUrl(`${url}portfoilo/resume/${latest}`);
        } else {
          setCurrentResumeUrl(null);
        }
      } catch (err) {
        console.error("Error fetching resumes:", err);
      }
    };

    fetchResume();
  }, []);

  return (
    <section className="about">
      <div className="about-container">
        <div className="about-card">
          {/* Profile Image */}
          <div className="profile">
            <img src="./Mohamed_Safvan.jpg" alt="Mohamed Safvan VP" />
            <div className="social-icons">
              <a
                href="https://github.com/safvan13058"
                target="_blank"
                rel="noopener noreferrer"
                className="github-btn"
              >
                <FaGithub />
              </a>
              {/* <a href="#"><FaDribbble /></a> */}
              <a href="tel:+918086945415"><FaPhone /></a>
              <a
                href="https://www.instagram.com/safvan_13058"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.linkedin.com/in/mohamedsafvanvp"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
              >
                <FaLinkedin />
              </a>
            </div>
          </div>

          {/* Text Content */}
          <div className="about-text">
            <h2>Full Stack Web Developer from Kerala, Working Globally</h2>
            <p>
              I'm <strong>Mohamed Safvan VP</strong>, a passionate <strong>Full Stack Developer based in Kerala, India</strong>, delivering modern web applications and smart embedded solutions to clients across the globe. Whether you're a startup or enterprise, I help you build reliable, scalable, and user-focused platforms.
            </p>
            <p>
              I specialize in <strong>MERN stack development</strong>, <strong>IoT systems</strong>, and <strong>robotics integration</strong>—blending cutting-edge software with innovative hardware. From local businesses in Kerala to international projects, I bring creativity and engineering together to solve real-world problems.
            </p>

            {/* Buttons */}
            <div className="buttons">
              <a href="#portfolio" className="btn primary">My Projects</a>

              {currentResumeUrl && (
                <a
                  href={currentResumeUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn secondary"
                >
                  Download CV
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
